import React from 'react';
import { BaseCompanyPage } from './BaseCompanyPage';
import { ManagerNavbar } from '../../Components/Navbars';

export const CompanyPageForOtherCompany = () => {
    return (
        <>
            <ManagerNavbar />
            <BaseCompanyPage />
        </>
    );
};